import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  titlePart1: {
    id: 'calendaruha.titlePart1',
    nb: 'Praksiskalender for',
    en: 'Practice calendar',
  },
  titlePart2: {
    id: 'calendaruha.titlePart2',
    nb: 'studieåret {year}',
    en: 'year {year}',
  },
  linkYear: {
    id: 'calendaruha.linkYear',
    nb: 'Studieår',
    en: 'Year',
  },
  subtitle: {
    id: 'calendaruha.subtitle',
    nb: 'Opprett en praksisaktivitet ved å trykke på pluss-tegnet i kalenderen',
    en: 'Create a practice activity by clicking on the plus sign in the calendar',
  },
  searchbarEmnefilterPlaceholder: {
    id: 'calendaruha.searchbar.emnefilter.placeholder',
    nb: 'Vis alle aktiviteter',
    en: 'See all activities',
  },
  practiceTypeGroupsConfirmationDialogTitle: {
    id: 'calendaruha.practiceTypeGroups.confirmationDialog.title',
    nb: 'Slette praksisklasse?',
    en: 'Delete group?',
  },
  practiceTypeGroupsConfirmationDialogContents1: {
    id: 'calendaruha.practiceTypeGroups.confirmationDialog.contents1',
    nb: 'Du prøver å slette en praksisklasse som har praksisaktiviteter tilknyttet seg.',
    en: 'You are trying to remove group with existing practice periods.',
  },
  practiceTypeGroupsConfirmationDialogContents2: {
    id: 'calendaruha.practiceTypeGroups.confirmationDialog.contents2',
    nb: 'Disse aktivitetene vil da også slettes.',
    en: 'Related practice periods will also be removed.',
  },
  practiceTypeGroupsConfirmationDialogContents3: {
    id: 'calendaruha.practiceTypeGroups.confirmationDialog.contents3',
    nb: 'Er du sikker på at du vil fortsette?',
    en: 'Do you want to proceed?',
  },
  practiceTypeGroupsGroupAdded: {
    id: 'calendaruha.practiceTypeGroups.groupAdded',
    nb: 'Praksisklasse opprettet',
    en: 'Group successfully added',
  },
  practiceTypeGroupsGroupRemoved: {
    id: 'calendaruha.practiceTypeGroups.groupRemoved',
    nb: 'Praksisklasse slettet',
    en: 'Group successfully removed',
  },
  emptyStateTitle: {
    id: 'calendaruha.emptyStateTitle',
    nb: 'Det er ingen tilgjengelige undervisningsdata for dette studieåret.',
    en: 'There are no data available for this year',
  },
  emptyStateText: {
    id: 'calendaruha.emptyStateText',
    nb: 'Sjekk grunnlagsdata i FS og kontroller at søket ditt er korrekt.',
    en: 'Make sure the data is correct in FS and make sure your filter is correct',
  },
};

export default translations;
